import domReady from '@wordpress/dom-ready';
import DataTable from 'datatables.net-dt';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { __ } from '@wordpress/i18n';

domReady(() => {
  const tableEl = document.querySelector('#user-listing-table');

  if (!tableEl) return;

  new DataTable(tableEl, {
    pageLength: 10,
    ordering: true,
    searching: true,
    info: false,
    lengthChange: false,
    language: {
      search: '', // remove the label "Search:"
      searchPlaceholder: __('Search by : First Name, Last Name', 'vtx'),
      paginate: {
        first: __('First page', 'vtx'),
        previous: '<i class="icon icon-icon-left"></i>',
        next: '<i class="icon icon-right"></i>',
        last: __('Last page', 'vtx'),
      },
    },
  });
});
